import { XStylesSettings } from '@shared/types/types';
import { RadioButtonProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const RadioButton = (props: RadioButtonProps) => {
  const {
    size = 'small',
    isDisabled = false,
    isChecked = false,
    changeFunction,
    settings,
    'data-testid': testId,
  } = props;

  return (
    <input
      type="radio"
      data-testid={testId}
      disabled={isDisabled}
      checked={isChecked}
      onChange={() => changeFunction()}
      {...stylex.props(styles.base(isChecked, isDisabled), styles[size], settings as XStylesSettings)}
    />
  );
};

export default RadioButton;
